// extracted by mini-css-extract-plugin
export default {"footer":"uh73gGvCwTh09YgBHCog","body":"nZyf15EQ87EmWEBFXM0e"};